import React from 'react';
import useBackUrl from '../hooks/backUrl';

const withBackUrl = (ComponentToWrap: any) => {
  const WithBackUrl = (props: any) => {
    const { backUrl, setBackUrl } = useBackUrl();
    return <ComponentToWrap backUrl={backUrl} setBackUrl={setBackUrl} {...props} />;
  };
  WithBackUrl.displayName = 'withBackUrl';

  return WithBackUrl;
};

export default withBackUrl;
